 
import $ from 'jquery';
import { gsap } from "gsap";
import './smartresize';
  
class FlexibleRowItem {
    constructor(el, i) {
        this.render(el, i);
    }


    setTitleHeight() {
 
        this.titleCol.css('min-height',this.mediaQuery.matches ? this.contentCol.outerHeight() : '');

    }

    render(el) {

        this.mediaQuery = window.matchMedia('(min-width: 640px)');
        this.el = $(el);
        this.titleCol = this.el.find('[data-ref="title-col"]')
        this.contentCol = this.el.find('[data-ref="content-col"]')
 
        this.setTitleHeight();

        $(window).smartresize(function () {
           
            this.setTitleHeight()
        }.bind(this));

    }

}
 



class FlexibleRow {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {

        new FlexibleRowItem(el, index);

    }
}


export default FlexibleRow;